import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../axios-instance'
import customer from './modules/customer.store'
import subscription from './modules/subscription.store'
import user from './modules/user.store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    /** States to handle error/success for put,post and delete requests
     * These states are directly connected to the error and success components in App.vue
     */
    errorMessages: [],
    successMessage: '',

    // States connected to the logged in user
    isLoggedIn: null,
    loggedInUser: null,
    customers: { data: null, error: null }
  },

  mutations: {
    // APP
    setErrorMessages: function (state, message) {
      state.errorMessages.push(message)
    },

    clearErrorMessages: function (state) {
      state.errorMessages = []
    },

    setSuccessMessage: function (state, message) {
      state.successMessage = message
    },

    setLoggedInUser: function (state, user) {
      state.loggedInUser = user
    },
    setLoggedIn: function (state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn
    },

    setCustomers: function (state, customers) {
      state.customers = customers
    },
    setCustomersError: function (state, error) {
      state.customers.error = error
    }
  },

  actions: {
    // APP
    fetchCustomers: function (context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/customers'
        })
          .then(function (response) {
            context.commit('setCustomers', { data: response.data, error: null })
            resolve()
          })
          .catch(function (error) {
            context.commit('setCustomersError', error.message)
            reject(error.message)
          })
      })
    },

    checkIfLoggedIn: function (context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/users/me'
        })
          .then(function (response) {
            context.commit('setLoggedIn', response.data.transientLoggedIn)
            if (response.data.transientLoggedIn) {
              context.commit('setLoggedInUser', { id: response.data.id, email: response.data.email })
            }
            resolve(response)
          })
          .catch(function (error) {
            console.error(error)
          })
      })
    },

    logOut: function (context) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: '/logout'
        })
          .then(function (response) {
            context.commit('setLoggedIn', false)
            context.dispatch('resetStates')
            resolve()
          })
          .catch(function (error) {
            console.error(error)
          })
      })
    },

    // TODO: Implement a reset states function
    resetStates: function (context) {
      context.commit('setLoggedInUser', null)
      context.commit('setLoggedIn', null)
      context.commit('setCustomers', { data: null, error: null })
    }

  },
  modules: {
    customer,
    subscription,
    user
  }
})
